import styled, {keyframes} from "styled-components";

const LiveStreamSlideStatusIconAnimation = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.25;
    }
    100% {
        opacity: 1;
    }   
`;

export const LiveStreamSlideStatusIconBox = styled.div`
    animation: ${LiveStreamSlideStatusIconAnimation} 2s ease infinite;
`;
